import React, { useState } from "react";
import classes from "./index.module.scss";
import ButtonComponent from "../../../components/ButtonComponent";
import { Input } from "../../../components/Input";
import { useForm } from "react-hook-form";
import { COLORS } from "../../../lib/colors";
import { Redirect } from "react-router-dom";
import * as HTTPServices from "../../../api/HTTPServices";
import { useTranslation } from "react-i18next";

function Index() {
  const { t } = useTranslation();
  const { register, handleSubmit } = useForm();
  // const [redirect, setRedirect] = useState(false);
  // const [redirectLink, setRedirectLink] = useState("");
  const [redirect] = useState(false);
  const [redirectLink] = useState("");

  const onSubmit = (data) => {
    let formData = new FormData();

    if (!data.price) {
      return alert("!price");
    }

    formData.append("price", data.price);

    const RequestService = HTTPServices.postMethod(
      "increase_credit",
      formData,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        window.location.href = response.pay_link;
      } else {
      }
    }).catch(function (error) {});
  };

  if (redirect) {
    return <Redirect to={redirectLink} />;
  }

  return (
    <div>
      <h3 className={classes.title}>
        {t("pages.protectedPages.increaseCredit.title")}
      </h3>
      <hr></hr>
      <div className={classes.formContainer}>
        <div className={classes.inerContainer}>
          <p>{t("pages.protectedPages.increaseCredit.account")}</p>
          <div>{t("pages.protectedPages.increaseCredit.credit")} 0</div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              autoFocus={true}
              autoComplete="off"
              {...register("price", { required: true })}
              placeholder={t("pages.protectedPages.increaseCredit.input")}
            />

            <div>
              <ButtonComponent
                width="100%"
                backgroundColor={COLORS.primary}
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {t("pages.protectedPages.increaseCredit.pay")}
              </ButtonComponent>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Index;
